import { useUserManagementStore } from "@hooks/stores";
import { User } from "@interfaces/user";
import { FilterValues } from "@pages/UserManagement/UserManagement.types";
import { SelectInput, SelectOption, useDebounce } from "@ucchub/ui";
import Paragraph from "@vfuk/core-paragraph";
import { Spacing } from "@vfuk/core-spacing";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState, ReactNode } from "react";

type DeleteSelectUserByOrgInputProps = {
  orgFilter: FilterValues | undefined;
  userId: User["userId"];
  setDelegateUserId: (userId: string) => void;
  setdelegateUserName: (userName: string | ReactNode) => void;
};

const DeleteSelectUserByOrgInput = ({
  orgFilter,
  userId,
  setDelegateUserId,
  setdelegateUserName,
}: DeleteSelectUserByOrgInputProps) => {
  const fetchUsers = useUserManagementStore((state) => state.getUsers.call);
  const { t } = useTranslation("translation", {
    keyPrefix: "shared:users",
  });
  const [users, setUsers] = useState<User[]>([]);
  const [selectedUserToDelete, setSelectedUserToDelete] =
    useState<SelectOption>();

  const [searchValue, setSearchValue] = useState("");

  const debouncedSearchValue = useDebounce<string>(searchValue, 500);
  const clearUsersData = useUserManagementStore((state) => state.clearUsers);

  const getUsersData = useCallback(async () => {
    if (debouncedSearchValue !== "") {
      clearUsersData();
    }
    const res: User[] = await fetchUsers(
      debouncedSearchValue || undefined,
      true,
      orgFilter
    );
    const users = Array.from(res || []);
    const alternateUsers = users.filter((user) => user.userId !== userId);
    setUsers(alternateUsers);
  }, [debouncedSearchValue, orgFilter]);

  useEffect(() => {
    getUsersData();
  }, [debouncedSearchValue]);

  const handleSelectUserOnChange = (selectedUserOption: SelectOption) => {
    setSelectedUserToDelete(selectedUserOption);
    setDelegateUserId(selectedUserOption.value);
    setdelegateUserName(selectedUserOption?.label);
  };
  return (
    <>
      <Spacing spacingLevel={{ bottom: 3 }}>
        <Paragraph justify="center">
          {t("modal:Delete_select_input.paragraph")}
        </Paragraph>
      </Spacing>
      <SelectInput
        label={t("modal:Delete_select_input.input_label")}
        id="user"
        value={selectedUserToDelete}
        options={users?.map((user) => ({
          value: user.userId,
          label: user.email,
        }))}
        onInputChange={(name: string) => {
          setSearchValue(name);
        }}
        onChange={handleSelectUserOnChange}
      />
    </>
  );
};

export default DeleteSelectUserByOrgInput;
